'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _appBadges = require('../../../../atoms/app-badges');

var _appBadges2 = _interopRequireDefault(_appBadges);

var _heading = require('../../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _button = require('../../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _mediaButton = require('../../../../atoms/media-button');

var _mediaButton2 = _interopRequireDefault(_mediaButton);

var _themeManager = require('../../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'home-carousel-hero';

var getAlignment = function getAlignment(textAlign) {
  var alignment = {
    left: ORGANISM_NAME + '__container col-xs-12 col-lg-8 text-xs-left',
    center: ORGANISM_NAME + '__container col-xs-12 col-lg-8 center-block text-xs-center'
  };
  return alignment[textAlign || 'center'];
};

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      { className: ORGANISM_NAME + '__headline' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph && paragraph.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__hatch-text pp-sans-small-regular' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var renderBadge = function renderBadge(content, clientInfo, isCentered) {
  var appBadgeContent = {
    clientInfo: clientInfo,
    ios: content.ios,
    android: content.android
  };
  var classes = isCentered ? ORGANISM_NAME + '__app-badge-wrapper--center' : ORGANISM_NAME + '__app-badge-wrapper';

  return _react2.default.createElement(
    'div',
    { className: classes },
    _react2.default.createElement(_appBadges2.default, appBadgeContent)
  );
};

var HomePageHero = function (_React$Component) {
  _inherits(HomePageHero, _React$Component);

  function HomePageHero(props) {
    _classCallCheck(this, HomePageHero);

    var _this = _possibleConstructorReturn(this, (HomePageHero.__proto__ || Object.getPrototypeOf(HomePageHero)).call(this, props));

    _this.getAlignment = getAlignment;
    _this.renderHeadline = renderHeadline;
    _this.renderParagraph = renderParagraph;
    _this.renderBadge = renderBadge;
    _this.renderHatchText = renderHatchText;
    _this.sectionElement = null;
    _this.state = {
      showImages: false
    };
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  _createClass(HomePageHero, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'renderMediaButton',
    value: function renderMediaButton(mediaButton) {
      if (mediaButton && mediaButton.text) {
        return _react2.default.createElement(
          _mediaButton2.default,
          {
            id: mediaButton.id,
            color: mediaButton.color,
            className: ORGANISM_NAME + '__mediabtn',
            fpti: 'HCarousel-MediaBtnSlide' + this.props.index + '-' + (mediaButton.fpti || mediaButton.text),
            'data-video-id': mediaButton['data-video-id']
          },
          mediaButton.text
        );
      }
      return null;
    }
  }, {
    key: 'renderCta',
    value: function renderCta(cta) {
      if (cta && cta.text) {
        var targetValue = cta.target || '_self';
        return _react2.default.createElement(
          _button2.default,
          {
            id: cta.id,
            href: cta.href,
            color: cta.color || null,
            className: ORGANISM_NAME + '__btn',
            fpti: 'HCarousel-' + (cta.type || 'cta') + 'Slide' + this.props.index + '-' + (cta.fpti || cta.text),
            target: targetValue
          },
          cta.text
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var theme = this.props.theme || 'theme-background-image-dark';
      var newProps = (0, _themeManager2.default)({ content: this.props.content }, theme);

      var content = newProps.content;
      var _props = this.props,
          config = _props.config,
          className = _props.className,
          clientInfo = _props.clientInfo,
          index = _props.index;
      var headline = content.headline,
          paragraph = content.paragraph,
          mediaButton = content.mediaButton,
          primaryCta = content.primaryCta,
          secondaryCta = content.secondaryCta,
          hatchText = content.hatchText;
      var showImages = this.state.showImages;


      var heroClasses = (0, _classnames2.default)(ORGANISM_NAME, className, this.props.height || 'tall', theme);

      var viewport = this.props.clientType;
      var shouldRenderBackground = !(typeof index === 'number' && !showImages && index >= 1);
      var backgroundImage = config.backgroundImage && (config.backgroundImage[viewport] || config.backgroundImage.url);
      var backgroundPosition = config.backgroundImage && config.backgroundPosition;
      var backgroundImageStyle = backgroundImage && shouldRenderBackground ? {
        backgroundImage: 'url(' + backgroundImage + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;

      var inlineStyle = Object.assign({}, this.props.style, backgroundImageStyle);
      var isCentered = config.deviceImageSize === 'large';

      return _react2.default.createElement(
        'section',
        {
          id: config.id ? config.id : null,
          className: heroClasses,
          'data-building-block': 'organism',
          style: inlineStyle,
          ref: function ref(el) {
            _this2.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: getAlignment(config.textAlign) },
              renderHeadline(headline),
              renderParagraph(paragraph),
              this.renderMediaButton(mediaButton),
              this.renderCta(primaryCta),
              this.renderCta(secondaryCta),
              this.renderBadge(content, clientInfo, isCentered),
              renderHatchText(hatchText)
            )
          )
        )
      );
    }
  }]);

  return HomePageHero;
}(_react2.default.Component);

exports.default = HomePageHero;


HomePageHero.propTypes = {
  // TODO: move this properties into config
  height: _propTypes2.default.oneOf(['short', 'tall']),
  theme: _propTypes2.default.oneOf(['theme-background-image-dark', 'theme-background-image-light', 'theme-new-money']),
  clientInfo: _propTypes2.default.shape({
    client_os_type: _propTypes2.default.string,
    client_is_mobile: _propTypes2.default.bool,
    client_type: _propTypes2.default.string
  }),
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      portable: _propTypes2.default.string.isRequired,
      mobile: _propTypes2.default.string.isRequired
    }).isRequired,
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right']),
    textAlign: _propTypes2.default.oneOf(['center', 'left']).isRequired
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    mediaButton: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      'data-video-id': _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      id: _propTypes2.default.string
    }),
    primaryCta: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }).isRequired,
    secondaryCta: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    ios: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    }),
    android: _propTypes2.default.shape({
      store: _propTypes2.default.oneOf(['google', 'android-store']),
      href: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  index: _propTypes2.default.number,
  clientType: _propTypes2.default.string
};

HomePageHero.defaultProps = {
  height: 'tall',
  theme: 'theme-background-image-dark',
  clientInfo: {
    client_os_type: 'ios',
    client_is_mobile: true,
    client_type: 'dedicated'
  },
  config: {
    id: '',
    textAlign: 'center',
    backgroundImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business.jpg',
      portable: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-medium.jpg',
      mobile: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-small.jpg'
    },
    backgroundPosition: 'center'
  },
  content: {
    headline: {
      text: '21 characters per line - 2 lines maximum.'
    },
    paragraph: {
      text: 'In mobile and tablet views, align text to optimize contrast with ' + 'background image. 152 characters max.'
    },
    mediaButton: {
      id: '',
      text: 'Fewer Than 25 Characters',
      'data-video-id': 'lkz4GZgyb9o'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: 'Fewer Than 29 Characters Max',
      target: '_self'
    },
    secondaryCta: {
      id: '',
      href: '#',
      text: 'Fewer Than 29 Characters Max',
      target: '_self'
    },
    ios: {
      href: 'https://app.adjust.com/vlx5gy',
      fpti: "home-hero-carousel"
    },
    android: {
      store: 'google',
      href: 'https://app.adjust.com/vxullh',
      fpti: "home-hero-carousel"
    },
    hatchText: {
      text: 'Fewer than 34 characters per line'
    }
  },
  className: '',
  style: {},
  index: 0,
  clientType: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/carousel/hero-carousel/jsx/HomePageHero.js
// module id = 1074
// module chunks = 4